import React from 'react';

export const DocumentsHero = () => (
  <div className="flex flex-row justify-between items-center relative min-h-[70px]">
    <div className="p-2 md:p-2 flex flex-col justify-center z-10 max-w-xl">
      <h1 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight">
        Space Designs Documents
      </h1>
      <p className="text-[11px] md:text-xs text-slate-400 font-medium tracking-wide mt-0.5">
        Secure document storage & collaboration
      </p>
    </div>

    <div 
      className="w-1/2 h-full absolute right-0 top-0 bottom-0 bg-cover bg-center rounded-xl overflow-hidden"
      style={{
        backgroundImage: `url(${require('../../../assets/Images/5.jpg')})`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#fbf8f1] via-[#fbf8f1]/70 to-transparent"></div>
    </div>
  </div>
);




